<template>
  <div class="comment-card">
    <bean-link
      v-if=" value.creator_type === 'User'"
      target="_blank"
      :to="{ name: 'users.show', params: { id: value.creator_id } }"
      keepNode
    >
      {{ value.creator ? value.creator.screen_name : value.creator_id }}
    </bean-link>
    <span v-else>管理员</span>
    <span> 在 {{ createTime }} 发起的{{ commentTypeName }}:</span>
    <div class="comment-content">{{ value.content }}</div>
    <div class="meta">
      <div class="meta-item" v-if="!value.parent_id">
        <img :src="require('@/assets/icon-comment.png')" />
        <span>{{ $get(value, 'commentable_comment_datum.comments_count') || 0 }}</span>
      </div>
      <div class="meta-item">
        <img :src="require('@/assets/icon-like.png')" />
        <span>{{ value.likes_count }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class CommentCard extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value;

  get createTime() {
    return moment(this.value.created_at).format('YYYY-MM-DD HH:mm:ss');
  }

  get commentTypeName() {
    const { cn, parent_id } = this.value;
    if (parent_id) {
      return '回复';
    }
    return {
      ExperienceComment: '读书会心得',
      YouthCampExperienceComment: '青训营心得',
      NormalComment: '评论'
    }[cn];
  }
}
</script>

<style lang="scss" scoped>
  .comment-card {
    padding: 10px;
  }

  .comment-content {
    line-height: 1.5;
    white-space: pre-line;
    margin: 10px 0;
  }

  .meta {
    display: flex;
    align-items: center;

    .meta-item {
      display: flex;
      align-items: center;

      img {
        width: 15px;
        margin-right: 2px;
      }

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
</style>
